import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const Booking = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <g fill="none">
            <path
                fill={color}
                fillRule="nonzero"
                d="M5.5,6.5 L5.5,17.5 L18.5,17.5 L18.5,6.5 L5.5,6.5 Z M5,5 L19,5 C19.5522847,5 20,5.44771525 20,6 L20,18 C20,18.5522847 19.5522847,19 19,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,6 C4,5.44771525 4.44771525,5 5,5 Z"
            />
            <path
                fill={color}
                fillRule="nonzero"
                d="M11.3545669,14.9999997 C11.5525218,15.000177 11.7424258,14.9107886 11.8824789,14.7515101 L14.7813317,11.4510574 C15.0728894,11.119108 15.0728894,10.5809116 14.7813317,10.2489621 C14.4897739,9.91701264 14.0170654,9.91701263 13.7255076,10.2489621 L11.3545669,12.948367 L10.2744924,11.7186617 C9.98293463,11.3867123 9.5102261,11.3867123 9.21866833,11.7186617 C8.92711056,12.0506112 8.92711056,12.5888076 9.21866831,12.9207571 L10.8341165,14.7515101 C10.972336,14.9087222 11.1592002,14.9979408 11.3545669,14.9999997 Z"
            />
        </g>
    </StarryUIIcon>
);
